import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Home from "./components/Home/Home";
import ServicePage from "./components/ServicePage/ServicePage";
import pages from "./data/pages.json";
import Privacy from "./delight/privacy/Privacy";
import DeleteAccount from "./delight/deleteAccount/DeleteAccount";
import ChildSafety from "./delight/childSafety/ChildSafety";
import "./App.css";

const HEADER_OFFSET = 72;

const scrollToId = (id, behavior) => {
  const el = id ? document.getElementById(id) : null;
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top, behavior });
  return true;
};

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  // One delegated listener handles every in-page anchor, including ones
  // rendered after the first paint.
  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;
      if (scrollToId(link.getAttribute("href").slice(1), "smooth")) e.preventDefault();
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  // On navigation, jump to the section in the URL (e.g. /#contact) or the top.
  useEffect(() => {
    if (!scrollToId(hash.slice(1), "auto")) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <div className="App">
          <ScrollHandler />
          <Routes>
            <Route path="/" element={<Home />} />
            {pages.services.map((page) => (
              <Route key={page.path} path={page.path} element={<ServicePage page={page} />} />
            ))}
            <Route path="/flirtolo/privacy" element={<Privacy />} />
            <Route path="/flirtolo/delete-account" element={<DeleteAccount />} />
            <Route path="/flirtolo/child-safety" element={<ChildSafety />} />
          </Routes>
        </div>
      </Router>
    </MotionConfig>
  );
}

export default App;
